import { z } from 'zod';

export const PageQuery = z.object({
  limit: z.coerce.number().int().min(1).max(200).default(50).describe('Page size (1-200).'),
  cursor: z.string().optional().describe('Opaque cursor from the previous page `nextCursor`.'),
});
export type PageQuery = z.infer<typeof PageQuery>;

export function page<T extends z.ZodType>(item: T) {
  return z.object({
    data: z.array(item),
    nextCursor: z
      .string()
      .nullable()
      .describe('Pass as `cursor` to get the next page; null at the end.'),
  });
}

export interface Page<T> {
  data: T[];
  nextCursor: string | null;
}
